import { useEffect, useState } from "react"
import getTours from "./services/getTours"
import Card from "./components/Card"
import { ICard } from "./types/cardType"
import { rearrangeItems } from "./helpers/siteHelpers"
import { paginateTours } from "./helpers/siteHelpers"
import { getKey } from "./helpers/siteHelpers"
import FilterMenu from "./components/FilterMenu"
declare const window: any;
const referer = window?.siteVar?.referer.toLowerCase()
const key = getKey(window.location.pathname)
import { isMobile } from "react-device-detect"
import { SquareLoader } from "react-spinners"

const Tours = () => {

    const [ definedTours, setDefinedTours ] = useState<ICard[]>([])
    const [ paginatedTours, setPaginatedTours ] = useState<ICard[][]|any>([])
    const [ page, setPage ] = useState(0)
    const [ showFilterMenu, setShowFilterMenu ] = useState(false)
    const [ filtered, setFiltered ] = useState<ICard[]>(definedTours)
    const [ isFiltered, setIsFiltered ] = useState(false)
    const [loading, setLoading ] = useState(true)
   
    const fetchData = async () => {
        let tours = await getTours( key, referer )
      
        if(tours.length > 0) {
            setLoading(false)
            tours = rearrangeItems('1',tours,referer)
            setDefinedTours(tours)
            setPaginatedTours(paginateTours(tours))
        }
    }

    useEffect(() => {
        setPaginatedTours(paginateTours(filtered))
        setPage(0)
    },[filtered])

    useEffect(() => {
        fetchData()
    },[])


    return (
        
        <>
        {loading && <SquareLoader />}
{ definedTours.length > 0 &&  //only return app if there are tours to show

<section className="container-fluid d-flex flex-column p-0 justify-content-center position-relative mx-auto">

    { showFilterMenu && 
            <FilterMenu
                definedTours = {definedTours}
                showFilterMenu = {showFilterMenu} 
                setShowFilterMenu = {setShowFilterMenu}
                setPaginatedTours = {setPaginatedTours}
                setFiltered = {setFiltered}
                isFiltered = { isFiltered }
                setIsFiltered = { setIsFiltered }
                isMobile = {isMobile}
                /> 
               }
      
    <div className={ "container d-flex p-0 row mt-5 mx-auto justify-content-center" }>

        {/* filter/sort buttons */}

        <div className={`mx-auto container p-0 col mb-3`}>

            <button className="btn btn-light rounded-0 col col-12 col-lg-3 p-3 float-start mb-3 mb-lg-0" 
                    onClick={() => {
                        setShowFilterMenu(!showFilterMenu)
                        setIsFiltered(false)}}>{showFilterMenu ? 'Reset Filters':'Refine Your Search'} 
                    <i className="material-icons ms-3 align-bottom"></i>
            </button>

            <label className="col col-12 col-lg-3 row float-end m-0">
               <span className="col-5 d-flex align-items-center justify-content-center">Sort by :</span>  
                <select className="bg-light border-0 p-3 text-dark w-100 col"
                    defaultValue={'1'} 
                    onChange={(e) => {
                        let tmp = rearrangeItems( e.target.value, filtered.length > 0 ?[...filtered] : [...definedTours], referer )
                        tmp && setPaginatedTours(paginateTours(tmp))}}>
                    <option value="1" >Tour Name</option>
                    <option value="2">Duration</option>
                    <option value="3">Guide Price</option>
                    <option value="4">Location</option>
                </select>
            </label>
        </div>

        <hr className="text-dark"/>
        <span className="mt-3 mb-3 text-center">
            <p>Count: { isFiltered ? filtered.length : definedTours.length }</p>
            { isFiltered && filtered.length === 0 &&
                <>
                <h3 className="py-5">No Results Found</h3>
                <button className="btn btn-dark p-3 rounded-0"
                        onClick={()=> {
                    setIsFiltered(false)
                    setPaginatedTours(paginateTours(definedTours))
                    setShowFilterMenu(false)
                }}>Reset Filters</button>
                </>
            }
        </span>

       <div className="row container-fluid justify-content-between m-0 p-0 w-100 mx-auto">
       
            { paginatedTours && paginatedTours.length > 0 && paginatedTours[page].map(( tour : ICard, index : number ) => {
                return (
                   <Card 
                         data={tour} 
                         referer={referer} 
                         isMobile={isMobile} 
                         key={index + '-' + tour.DDTourName} />
                )
            })}
        </div>
        <hr/>
    </div>
       
        <div className="container d-flex flex-row justify-content-center align-items-center m-0 mb-5 mx-auto">
            <i className="icon-chevron_left hover me-3" onClick={()=> setPage(page > 0 ? page - 1 : page)}></i>
        { paginatedTours && paginatedTours.length > 0 && paginatedTours.map((item : ICard[], index : number) => {
                return (
                    <p className={index === page ? `text-strong text-xl hover p-1 mb-0 border-bottom border-3 border-warning m-1 ${item[index]}` : 'm-1 hover p-1 mb-0'} 
                       key={'tourPageindex' + index} 
                       onClick={()=> setPage(index)}> { index + 1} </p>
                )
            })}
             <i className="icon-chevron_right hover ms-3" onClick={()=> setPage(page < paginatedTours.length -1 ? page + 1 : page)}></i>
        </div>

</section>
}
</>
)
}
export default Tours